import type { Production } from "@proof/core";
import { Select, Control, Toggle } from "./components";

export function PageMarks({
  value,
  onChange,
}: {
  value: Production;
  onChange: (value: Production) => void;
}) {
  return (
    <>
      <Toggle
        label="Crop marks"
        value={value.cropMarks}
        onChange={(cropMarks) => onChange({ ...value, cropMarks })}
      />
      <Toggle
        label="Bleed boundary marks"
        value={!!value.bleedMarks}
        onChange={(bleedMarks) => onChange({ ...value, bleedMarks })}
      />
      {(["crop", "bleed"] as const).map((kind) => {
        if (!(kind === "crop" ? value.cropMarks : value.bleedMarks))
          return null;
        const key = kind === "crop" ? "markSettings" : "bleedMarkSettings";
        const settings: NonNullable<Production["markSettings"]> = value[
          key
        ] || {
          length: kind === "crop" ? 8 : 9,
          offset: kind === "crop" ? 4 : 3,
          strokeWidth: 0.5,
        };
        const label = kind === "crop" ? "Page mark" : "Bleed mark";
        return (
          <div key={kind} className="control-grid">
            <Toggle
              label={`Combine ${label.toLowerCase()}s`}
              value={
                !!value[
                  kind === "crop" ? "combineCropMarks" : "combineBleedMarks"
                ]
              }
              onChange={(combined) =>
                onChange({
                  ...value,
                  [kind === "crop" ? "combineCropMarks" : "combineBleedMarks"]:
                    combined || undefined,
                })
              }
            />
            {kind === "crop" && (
              <Control label="Page mark offset reference">
                <Select
                  value={settings.reference || "bleed"}
                  onChange={(e) =>
                    onChange({
                      ...value,
                      [key]: {
                        ...settings,
                        reference: e.target.value as "trim" | "bleed",
                      },
                    })
                  }
                >
                  <option value="bleed">Bleed boundary</option>
                  <option value="trim">Trim boundary</option>
                </Select>
              </Control>
            )}
            {(["length", "offset", "strokeWidth", "outlineWidth"] as const).map(
              (property) => (
                <Control
                  key={property}
                  label={`${label} ${property === "strokeWidth" ? "stroke" : property === "outlineWidth" ? "white outline" : property} (pt)`}
                >
                  <input
                    type="number"
                    step={0.1}
                    min={
                      property === "length"
                        ? 1
                        : property === "strokeWidth"
                          ? 0.1
                          : 0
                    }
                    max={
                      property === "outlineWidth"
                        ? 4
                        : property === "strokeWidth"
                          ? 2
                          : 144
                    }
                    value={settings[property] ?? 0}
                    onChange={(e) =>
                      onChange({
                        ...value,
                        [key]: {
                          ...settings,
                          [property]: Number(e.target.value),
                        },
                      })
                    }
                  />
                </Control>
              ),
            )}
          </div>
        );
      })}
    </>
  );
}
